exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.arrow-square[data-v-76fbd6ec],ul.arrow[data-v-76fbd6ec],ul.check-circle[data-v-76fbd6ec],ul.check-square[data-v-76fbd6ec],ul.check[data-v-76fbd6ec],ul.chevron[data-v-76fbd6ec],ul.circle[data-v-76fbd6ec],ul.decimal[data-v-76fbd6ec],ul.lower-latin[data-v-76fbd6ec],ul.triangle[data-v-76fbd6ec],ul.upper-latin[data-v-76fbd6ec],ul.upper-roman[data-v-76fbd6ec]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-76fbd6ec]{font-size:1.6em}.booking-information[data-v-76fbd6ec]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76fbd6ec","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/infos/prohibited-items/Home.vue
// module id = 499
// module chunks = 0